import React from 'react'

import Body from '../Body'
import Header from '../Header'
import styles from './index.module.css'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const Wrapper = ({ children }: Props) => (
  <div className={styles.container}>
    <Header />
    <Body>{children}</Body>
  </div>
)

export default Wrapper
